import { useEffect } from 'react';
import { useViewer } from 'hooks/useViewer';
import SubscriptionCard from 'components/CoachDetails/SubscriptionCard';
import SubscriptionTime from './SubscriptionTime';
import { PremiumPlayerSideProps } from './props';
import SubscriptionPay from '../../../components/Premium/SubscriptionPay';
import CreateAccount from '../LessonScheduler/CreateAccount';
import Login from '../LessonScheduler/Login';
import { Steps } from '../types';

const PremiumPlayerSide: React.FC<PremiumPlayerSideProps> = ({
  coachId,
  coachName,
  amount,
  steps,
  setSteps,
  playerSubscribedUntil,
  toggleTabSwitch,
  onSubscriptionSuccess,
  currency,
}) => {
  const viewer = useViewer();

  const handleInitiateSubscribe = () => {
    setSteps(viewer.isAnonymousSession ? Steps.CreateAccount : Steps.SubscriptionPay);
  };

  useEffect(() => {
    if (!toggleTabSwitch) return;
    if (steps === Steps.Subscription || steps === Steps.SubscriptionTime) {
      toggleTabSwitch?.(true);
    } else {
      toggleTabSwitch?.(false);
    }
  }, [steps]);

  useEffect(() => {
    setSteps(playerSubscribedUntil ? Steps.SubscriptionTime : Steps.Subscription);
  }, [playerSubscribedUntil, viewer.userId]);

  return (
    <>
      {steps === Steps.Subscription && (
        <SubscriptionCard
          amount={amount}
          standalone={false}
          showMore
          onSubscribe={handleInitiateSubscribe}
          coachId={coachId}
          coachName={coachName}
          currency={currency}
        />
      )}
      {steps === Steps.CreateAccount && (
        <CreateAccount setSteps={setSteps} handleNext={() => null} />
      )}
      {steps === Steps.Login && <Login setSteps={setSteps} handleNext={() => null} />}
      {steps === Steps.SubscriptionPay && (
        <SubscriptionPay
          coachId={coachId}
          amount={amount}
          className="overflow-y-auto p-ds-xl max-sm:max-h-[calc(100dvh-3rem)] sm:max-h-[calc(100dvh-6rem)]"
          onBack={() => setSteps(Steps.Subscription)}
          onSuccess={onSubscriptionSuccess}
          currency={currency}
        />
      )}
      {steps === Steps.SubscriptionTime && (
        <SubscriptionTime
          standalone={false}
          coachId={coachId}
          date={playerSubscribedUntil}
          className="mt-8"
        />
      )}
    </>
  );
};

export default PremiumPlayerSide;
